import React, { Component } from "react";
import { GOOGLE_API_KEY } from "../../../config/Keys";
import Map from "./Map";
import isEmpty from "../../../store/validation/is-Empty";

const googleMapsApiKey = GOOGLE_API_KEY;

export class TestMap extends Component {
  constructor(props) {
    super(props);
    this.state = {
      latitude: "",
      longitude: "",
      places: [
        { latitude: 26.218287, longitude: 78.182831 },
        { latitude: 26.239759, longitude: 78.1533906 },
      ],
      travelMode: "",
    };
  }

  static getDerivedStateFromProps(nextProps, nextState) {
    // console.log("nextProps ==>", nextProps);
    if (
      !isEmpty(nextProps?.restaurantLocation?.coordinates) &&
      !isEmpty(nextProps?.userLocation)
    ) {
      return {
        places:
          !isEmpty(nextProps?.restaurantLocation?.coordinates) &&
            !isEmpty(nextProps?.userLocation)
            ? [
              {
                latitude: parseFloat(nextProps?.userLocation?.latitude),
                longitude: parseFloat(nextProps?.userLocation?.longitude),
              },
              {
                latitude: nextProps?.restaurantLocation?.coordinates[1],
                longitude: nextProps?.restaurantLocation?.coordinates[0],
              },
            ]
            : [],
        travelMode: nextProps?.travelMode,
      };
    }
  }

  updateMap = () => {
    let newPlaces = [
      {
        latitude: parseFloat(this.props?.userLocation?.latitude),
        longitude: parseFloat(this.props?.userLocation?.longitude),
      },
      {
        latitude: this.props?.restaurantLocation?.coordinates[1],
        longitude: this.props?.restaurantLocation?.coordinates[0],
      },
    ];
    this.setState({ places: newPlaces });
  };

  componentDidUpdate(prevProps) {
    if (
      !isEmpty(this.props.userLocation) &&
      this.props?.userLocation?.latitude &&
      this?.props?.userLocation?.longitude &&
      parseFloat(prevProps?.userLocation?.latitude) !==
      parseFloat(this.props?.userLocation?.latitude)
    ) {
      this.updateMap();
    }
  }

  render() {
    // console.log(this.state.places);
    return (
      <React.Fragment>
        <TrackScreen
          defaultZoom={7}
          places={
            this.state && [
              {
                // latitude: parseFloat(this.props?.userLocation?.latitude),
                // longitude: parseFloat(this.props?.userLocation?.longitude),
                latitude: parseFloat(this.props?.restaurantLocation?.coordinates[1]),
                longitude: parseFloat(this.props?.restaurantLocation?.coordinates[0]),
              },
              {
                latitude: this.props?.restaurantLocation?.coordinates[1],
                longitude: this.props?.restaurantLocation?.coordinates[0],
              },
            ]
          }
          mapPositionRestaurant={this.props?.restaurantLocation?.coordinates}
          travelMode={this.props.travelMode}
        />
      </React.Fragment>
    );
  }
}
export default TestMap;

const TrackScreen = (props) => {
  const { places, mapPositionRestaurant, travelMode } = props;

  const {
    loadingElement,
    containerElement,
    mapElement,
    defaultCenter,
    defaultZoom,
  } = props;
  //console.log(props);
  return (
    <Map
      googleMapURL={
        "https://maps.googleapis.com/maps/api/js?key=" +
        googleMapsApiKey +
        "&libraries=geometry,drawing,places"
      }
      markers={places}
      loadingElement={loadingElement || <div style={{ height: `100%` }} />}
      containerElement={containerElement || <div style={{ height: "40vh" }} />}
      mapElement={mapElement || <div style={{ height: `100%` }} />}
      defaultCenter={
        defaultCenter || {
          lat: mapPositionRestaurant?.[1],
          lng: mapPositionRestaurant?.[0],
        }
      }
      defaultZoom={defaultZoom || 11}
      travelMode={travelMode}
    />
  );
};

// const places = [
//   { latitude: 26.218287, longitude: 78.182831 },
//   { latitude: 26.239759, longitude: 78.1533906 },
// ];
